import { NoContentMessage } from '~/app/features/Gallery/components/PreviewArea/NoResultsMessage/NoContentMessage'
import { NoKeywordResultMessage } from '~/app/features/Gallery/components/PreviewArea/NoResultsMessage/NoKeywordResultMessage'
import { useSearchParams } from '~/app/features/Gallery/hooks/useSearchParams'

export const NoResultsMessage = () => {
  const searchParams = useSearchParams()

  const keyword = searchParams.get('keyword')

  return (
    <div className="preview-message py-m">
      {!keyword && <NoContentMessage />}
      {keyword && <NoKeywordResultMessage keyword={keyword} />}
    </div>
  )
}

NoResultsMessage.displayName = 'NoResultsMessage'
